module.exports = __webpack_public_path__ + "static/telegrotesknext-bold-webfont-6ba9b743b528724766deb2bdd57a3585.woff2";